import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ToggleSwitchDivision from './styled/ToggleSwitchDivision';

const getIsOff = (isDisabled, isActive) => { return !isDisabled && !isActive; };
const getIsOn = (isDisabled, isActive) => { return !isDisabled && isActive; };
const getInfoText = (isDisabled, toggleInfo) => { return isDisabled ? toggleInfo.disabledText : toggleInfo.enabledText; };

const ToggleSwitch = ({
  isActive,
  isDisabled,
  label,
  toggleInfo,
  handleClick,
  toggleClass,
}) => {
  const isOff = getIsOff(isDisabled, isActive);
  const isOn = getIsOn(isDisabled, isActive);
  const info = getInfoText(isDisabled, toggleInfo);

  return (
    <ToggleSwitchDivision
      aria-checked={isOn}
      aria-describedby="toggle-info"
      aria-disabled={isDisabled}
      aria-label={label}
      className={classNames('toggle', toggleClass, {
        'toggle--disabled': isDisabled,
        'toggle--off': isOff,
        'toggle--on': isOn,
      })}
      onClick={!isDisabled ? handleClick : undefined}
      role="switch"
      type="button"
    >
      <p className="toggle__info" id="toggle-info">
        {info}
      </p>
      <span className="toggle__switch" />
    </ToggleSwitchDivision>
  );
};

ToggleSwitch.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  toggleClass: PropTypes.string.isRequired,
  toggleInfo: PropTypes.shape({
    disabledText: PropTypes.string.isRequired,
    enabledText: PropTypes.string.isRequired,
  }).isRequired,
};

export default ToggleSwitch;
